(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["furniture-converter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initFurnitureConverter(section) {
      const debug = section.dataset.debug === 'true';
      const debugPanel = section.querySelector('[data-debug-panel]');

      function debugLog(message, isError = false) {
        if (!debug) return;
        console.log(`[FurnitureConverter] ${message}`);
        if (!debugPanel) return;

        const entry = document.createElement('div');
        entry.className = `furniture-converter__debug-entry${isError ? ' furniture-converter__debug-entry--error' : ''}`;
        entry.textContent = message;
        debugPanel.appendChild(entry);
      }

      const dataEl = section.querySelector('script[type="application/json"]');
      if (!dataEl) {
        debugLog('No JSON script element found. Metaobject ranges are probably empty.', true);
        return;
      }

      let data;
      try {
        data = JSON.parse((dataEl.textContent || '').trim());
        debugLog('JSON parsed successfully.');
      } catch (error) {
        debugLog(`JSON parse failed: ${error.message}`, true);
        return;
      }

      const ranges = Array.isArray(data.ranges) ? data.ranges : [];
      debugLog(`Loaded ${ranges.length} range(s) from JSON.`);

      const rangeList = section.querySelector('[data-range-list]');
      const itemList = section.querySelector('[data-item-list]');
      const conversionList = section.querySelector('[data-conversion-list]');
      const productList = section.querySelector('[data-product-list]');
      const statusEl = section.querySelector('[data-status]');
      const addAllButton = section.querySelector('[data-add-all]');
      const stepEls = section.querySelectorAll('.furniture-converter__step');
      if (!rangeList || !itemList || !conversionList || !productList || !addAllButton) {
        debugLog('Missing one or more required DOM nodes for the converter UI.', true);
        return;
      }

      ranges.forEach((range, rangeIndex) => {
        const items = Array.isArray(range.items) ? range.items : [];
        debugLog(`Range ${rangeIndex + 1}: "${range.title || range.id || 'untitled'}" has ${items.length} item(s).`);

        items.forEach((item, itemIndex) => {
          const conversions = Array.isArray(item.conversions) ? item.conversions : [];
          debugLog(
            `  Item ${itemIndex + 1}: "${item.title || item.id || 'untitled'}" has ${conversions.length} conversion(s).`
          );

          conversions.forEach((conversion, conversionIndex) => {
            const products = Array.isArray(conversion.products) ? conversion.products : [];
            debugLog(
              `    Conversion ${conversionIndex + 1}: "${conversion.title || conversion.id || 'untitled'}" has ${products.length} product(s).`
            );
          });
        });
      });

      const state = {
        selectedRangeId: null,
        selectedItemId: null,
        selectedConversionId: null
      };

      const translations = {
        selectRange: section.dataset.selectRange || 'Select a range first.',
        selectBed: section.dataset.selectBed || 'Select your current bed first.',
        selectConversion: section.dataset.selectConversion || 'Select a conversion option first.',
        noConversions: section.dataset.noConversions || 'No conversion options are available for this bed.',
        noProducts: section.dataset.noProducts || 'No products are linked to this conversion kit.',
        addAllSuccess: section.dataset.addAllSuccess || 'All kit products were added to your cart.',
        addAllError: section.dataset.addAllError || 'Could not add all products to cart. Please try again.',
        viewProduct: section.dataset.viewProductLabel || 'View product',
        noRanges: 'No furniture ranges are available yet.'
      };

      function createOptionCard(option, isSelected) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'furniture-converter__option';
        button.setAttribute('aria-pressed', String(Boolean(isSelected)));

        if (option.image) {
          const img = document.createElement('img');
          img.src = option.image;
          img.alt = option.title || '';
          button.appendChild(img);
        }

        const title = document.createElement('span');
        title.className = 'furniture-converter__option-title';
        title.textContent = option.title || '';
        button.appendChild(title);

        return button;
      }

      function getSelectedRange() {
        return ranges.find((range) => range.id === state.selectedRangeId) || null;
      }

      function getSelectedItem() {
        const range = getSelectedRange();
        if (!range || !Array.isArray(range.items)) return null;
        return range.items.find((item) => item.id === state.selectedItemId) || null;
      }

      function getSelectedConversion() {
        const item = getSelectedItem();
        if (!item || !Array.isArray(item.conversions)) return null;
        return item.conversions.find((conversion) => conversion.id === state.selectedConversionId) || null;
      }

      function setStatus(message) {
        if (statusEl) statusEl.textContent = message || '';
      }

      function scrollToStep(stepIndex) {
        const targetStep = stepEls[stepIndex];
        if (!targetStep) return;
        targetStep.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }

      function renderRanges() {
        rangeList.innerHTML = '';
        if (!ranges.length) {
          rangeList.innerHTML = `<p>${translations.noRanges}</p>`;
          return;
        }

        ranges.forEach((range) => {
          const button = createOptionCard(
            { title: range.title, image: null },
            state.selectedRangeId === range.id
          );
          button.addEventListener('click', () => {
            state.selectedRangeId = range.id;
            state.selectedItemId = null;
            state.selectedConversionId = null;
            renderRanges();
            renderItems();
            renderConversions();
            renderProducts();
            setStatus('');
            scrollToStep(1);
          });
          rangeList.appendChild(button);
        });
      }

      function renderItems() {
        itemList.innerHTML = '';

        const range = getSelectedRange();
        if (!range) {
          itemList.innerHTML = `<p>${translations.selectRange}</p>`;
          return;
        }

        const items = Array.isArray(range.items) ? range.items : [];
        items.forEach((item) => {
          const button = createOptionCard(item, state.selectedItemId === item.id);
          button.addEventListener('click', () => {
            state.selectedItemId = item.id;
            state.selectedConversionId = null;
            renderItems();
            renderConversions();
            renderProducts();
            setStatus('');
            scrollToStep(2);
          });
          itemList.appendChild(button);
        });
      }

      function renderConversions() {
        conversionList.innerHTML = '';

        const item = getSelectedItem();
        if (!item) {
          conversionList.innerHTML = `<p>${translations.selectBed}</p>`;
          return;
        }

        const conversions = Array.isArray(item.conversions) ? item.conversions : [];
        if (!conversions.length) {
          conversionList.innerHTML = `<p>${translations.noConversions}</p>`;
          return;
        }

        conversions.forEach((conversion) => {
          const option = {
            title: conversion.endProduct && conversion.endProduct.title ? conversion.endProduct.title : conversion.title,
            image: conversion.endProduct ? conversion.endProduct.image : null
          };
          const button = createOptionCard(option, state.selectedConversionId === conversion.id);
          button.addEventListener('click', () => {
            state.selectedConversionId = conversion.id;
            renderConversions();
            renderProducts();
            setStatus('');
            scrollToStep(3);
          });
          conversionList.appendChild(button);
        });
      }

      function renderProducts() {
        productList.innerHTML = '';
        addAllButton.disabled = true;

        const conversion = getSelectedConversion();
        if (!conversion) {
          productList.innerHTML = `<p>${translations.selectConversion}</p>`;
          return;
        }

        const products = Array.isArray(conversion.products) ? conversion.products : [];
        if (!products.length) {
          productList.innerHTML = `<p>${translations.noProducts}</p>`;
          return;
        }

        products.forEach((product) => {
          const article = document.createElement('article');
          article.className = 'furniture-converter__product';

          if (product.featuredImage) {
            const image = document.createElement('img');
            image.className = 'furniture-converter__product-image';
            image.src = product.featuredImage;
            image.alt = product.title || '';
            article.appendChild(image);
          }

          const body = document.createElement('div');
          body.className = 'furniture-converter__product-body';
          body.innerHTML = `
            <h3 class="furniture-converter__product-title">${product.title || ''}</h3>
            <p class="furniture-converter__product-price">${product.price || ''}</p>
            <a class="furniture-converter__product-link" href="${product.url || '#'}">${translations.viewProduct}</a>
          `;
          article.appendChild(body);

          productList.appendChild(article);
        });

        addAllButton.disabled = false;
      }

      async function addAllProductsToCart() {
        const conversion = getSelectedConversion();
        if (!conversion || !Array.isArray(conversion.products)) return;

        const items = conversion.products
          .filter((product) => product.available && product.variantId)
          .map((product) => ({
            id: Number(product.variantId),
            quantity: 1
          }));

        if (!items.length) {
          setStatus(translations.noProducts);
          return;
        }

        addAllButton.disabled = true;
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ items })
          });

          if (!response.ok) throw new Error('Request failed');
          setStatus(translations.addAllSuccess);
          document.dispatchEvent(new CustomEvent('cart:build'));
        } catch (error) {
          setStatus(translations.addAllError);
        } finally {
          addAllButton.disabled = false;
        }
      }

      addAllButton.addEventListener('click', addAllProductsToCart);

      renderRanges();
      renderItems();
      renderConversions();
      renderProducts();
    }

    document.querySelectorAll('.furniture-converter').forEach(initFurnitureConverter);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-header"]) return;
  try {
    
  class MainHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = false;
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(min-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.onOverlayOpenHandler = this.onOverlayOpen.bind(this);
      this.onOverlayCloseHandler = this.onOverlayClose.bind(this);

      window.addEventListener('open.hs.overlay', this.onOverlayOpenHandler, false);
      window.addEventListener('close.hs.overlay', this.onOverlayCloseHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    onOverlayOpen() {
      requestAnimationFrame(this.openOverlay.bind(this));
    }

    onOverlayClose() {
      requestAnimationFrame(this.closeOverlay.bind(this));
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    openOverlay() {
      this.header.classList.add('drawer-open');
    }

    closeOverlay() {
      this.header.classList.remove('drawer-open');
    }
  }

  customElements.define('main-header', MainHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
  function swymCallbackFn(swat) {
    document.addEventListener("variantChange", function(event) {
      /* the current selected variant id */
      var variantId = event.detail.variant.id;
      window.triggerSwymVariantEvent(variantId);
      /* parent container of the where the button is rendered */
      swat.initializeActionButtons(".js-wishlist-button-wrapper");
    });
  }

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["set-recently-viewed"]) return;
  try {
    
  class SetRecentlyViewedProduct extends HTMLElement {
    constructor() {
      super();
      RecentlyViewed.setRecentlyViewed(this.dataset.handle);
    }
  }

  window.addEventListener('DOMContentLoaded', () => {
    if (window.RecentlyViewed) {
      customElements.define('set-recently-viewed-product', SetRecentlyViewedProduct);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
